import React, { useState, useMemo } from "react";
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";

const AdnMenuComponent = ({
  onMenuSelect,
  userHasRole,
  selectedKey,
  menuItems,
}) => {
  const [openKeys, setOpenKeys] = useState([]);

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  const renderMenuItem = (item) => {
    if (typeof item.roles === "string" && !userHasRole(item.roles)) {
      return null;
    }

    if (item.children) {
      const visibleChildren = item.children
        .map((child) => renderMenuItem(child))
        .filter(Boolean);

      if (visibleChildren.length === 0) {
        return null;
      }

      return (
        <SubMenu key={String(item.key)} icon={item.icon} title={item.label}>
          {visibleChildren}
        </SubMenu>
      );
    }

    return (
      <Menu.Item
        key={String(item.key)}
        icon={item.icon}
        onClick={() =>
          onMenuSelect({ route: item.route, key: String(item.key) })
        }
      >
        {item.label}
      </Menu.Item>
    );
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={[String(selectedKey)]}
      openKeys={openKeys}
      onOpenChange={handleOpenChange}
    >
      <Menu.ItemGroup title="top">
        {menuItems.map(renderMenuItem)}
      </Menu.ItemGroup>
    </Menu>
  );
};

export default AdnMenuComponent;
